<template>
  <div>
    <TransactionEditModal v-if="modal_type === 'basic'"
                          :transaction="transaction"
                          :position="position"
                          @success="$emit('finished')"
                          @transformToTransfer="modal_type = 'transform';"
                          @close="$emit('close')"/>
    <TransactionToTransferModal v-if="modal_type === 'transform'"
                                :transaction="transaction"
                                :position="position"
                                @success="$emit('finished')"
                                @close="modal_type = 'basic';$emit('close')"/>
  </div>
</template>

<script>
import TransactionEditModal
  from "@/components/common/Transaction/TransactionEditModal/TransactionEditModal";
import TransactionToTransferModal
  from "@/components/common/Transaction/TransactionEditModal/TransactionToTransferModal";

export default {
  name: "TransactionEditModalProvider",
  components: {TransactionToTransferModal, TransactionEditModal},
  data() {
    return {
      modal_type: 'basic',
    }
  },
  props: {
    transaction: {
      Type: Object,
      required: true
    },
    position: {
      type: String,
      default: 'relative'
    }
  }
}
</script>